export const subscribe = (eventName, listener) => {
  document.addEventListener(eventName, listener);
};
export const unsubscribe = (eventName, listener) => {
  document.removeEventListener(eventName, listener);
};
export const publish = (eventName, detail) => {
  const event = new CustomEvent(eventName, {
    detail: detail,
  });
  document.dispatchEvent(event);
};

export const addListeners = () => {
  addNotificationListener();
};

export const addNotificationListener = () => {
  subscribe("visibilitychange", () => {
    if (
      document.visibilityState === "visible" &&
      document.location.pathname === "/chats"
    ) {
      document.title = "Conversaciones | Trini Talkbot";
    }
  });
  subscribe("notification", (data) => {
    if (document.visibilityState === "hidden") {
      document.title = "(*) Conversaciones | Trini Talkbot";

      if ("Notification" in window) {
        // Verifica si el navegador soporta notificaciones
        Notification.requestPermission().then(function (permission) {
          if (permission === "granted") {
            // Si se concede el permiso, crea la notificación

            new Notification(data.detail?.name, {
              body: data.detail?.body,
              icon: "https://ui.trinitalkbot.com/static/media/triniIcon.c0d6f72994d18105a007.png",
              tag: data.detail?.tag,
            });
          }
        });
      } else {
        console.error("Este navegador no soporta notificaciones");
      }
      var resp = document.getElementById("msg-audio")?.play();
      if (resp !== undefined) {
        resp
          .then(() => {
            // autoplay starts!
          })
          .catch(() => {
            //show error
          });
      }
    }
  });
};
